"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/Forms/Coworker.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reacthookform = require('react-hook-form');


var _coworker = require('shared/validation/invite/coworker');
var _org = require('shared/selectors/org');
var _user = require('shared/selectors/user');
var _hooks = require('web/services/hooks');




var _Form = require('web/components/Form');
var _Modal = require('web/components/Modal');














const CoworkerForm = ({
  submitBtnLabel,
  onCancel,
  onSubmit,
  controlsClassName,
  beforeControls,
  defaultEmail,
  defaultFirstName,
  defaultLastName,
  hideOrgNotice,
  orgKeyContext,
}) => {
  const orgName = _hooks.useAppSelector.call(void 0, 
    state => orgKeyContext && _optionalChain([_org.selectOrgByKey.call(void 0, orgKeyContext, state), 'optionalAccess', _ => _.Name]) || '',
  )
  const amIAnAdmin = _hooks.useAppSelector.call(void 0, state => _user.selectAmIAdminInOrg.call(void 0, state, orgKeyContext))
  const { register, control, handleSubmit, formState, setValue } =
    _reacthookform.useForm({
      resolver: _coworker.coworkerResolver,
      mode: 'onChange',
      defaultValues: {
        firstName: defaultFirstName || '',
        lastName: defaultLastName || '',
        title: '',
        isAdmin: false,
        email: defaultEmail || '',
      },
    })
  const { isValid, isSubmitting, isDirty, errors } = formState
  _react.useEffect.call(void 0, () => { register('isAdmin') }, [register])
  _react.useEffect.call(void 0, () => {
    if (!amIAnAdmin) setValue('isAdmin', false)
  }, [amIAnAdmin, orgKeyContext, setValue])

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  orgName && !hideOrgNotice && (
        _react2.default.createElement('span', { className: "directory--create-new--notice", __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}, "This coworker will be invited to "
                , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}, orgName), "."
        )
      )
      , _react2.default.createElement(_Form.InputSectionGroup, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
        , _react2.default.createElement(_Form.InputSection, {
          autoFocus: !defaultFirstName,
          title: "First Name" ,
          placeholder: "E.g. John" ,
          inputProps: register('firstName'),
          errorMessage: _optionalChain([errors, 'access', _2 => _2.firstName, 'optionalAccess', _3 => _3.message]),
          className: "directory--create-new--input-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
        )
        , _react2.default.createElement(_Form.InputSection, {
          title: "Last Name" ,
          placeholder: "E.g. Parker" ,
          inputProps: register('lastName'),
          errorMessage: _optionalChain([errors, 'access', _4 => _4.lastName, 'optionalAccess', _5 => _5.message]),
          className: "directory--create-new--input-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
        )
      )
      , _react2.default.createElement(_Form.InputSection, {
        autoFocus: !!(defaultFirstName && defaultLastName),
        isOptional: true,
        title: "Title",
        placeholder: "E.g. Head Nurse"  ,
        inputProps: register('title'),
        errorMessage: _optionalChain([errors, 'access', _6 => _6.title, 'optionalAccess', _7 => _7.message]),
        className: "directory--create-new--input-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}
      )
      , _react2.default.createElement(_Form.InputSection, {
        title: "Email",
        placeholder: "E.g. john@email.com" ,
        inputProps: register('email'),
        errorMessage: _optionalChain([errors, 'access', _8 => _8.email, 'optionalAccess', _9 => _9.message]),
        className: "directory--create-new--input-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}
      )
      ,  amIAnAdmin && (
        _react2.default.createElement(_Form.InputSectionWrapper, { title: "Role", __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}
          , _react2.default.createElement(_Form.ToggleController, {
            control: control,
            name: "isAdmin",
            label: "Administrator",
            hint: "Administrators can manage this organization's subscription, change organization settings, and manage other members."            , __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}
          )
        )
      )
      ,  beforeControls 
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnLabel: submitBtnLabel,
        isPrimaryEnabled: isValid && isDirty && !isSubmitting,
        onPrimaryBtnClick: handleSubmit(onSubmit),
        isPrimaryLoading: isSubmitting,
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: onCancel,
        className: controlsClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 114}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, CoworkerForm)
